/** The address the Google preview shows for a route. Pure. */

/**
 * The site's address for `path` in `language`: bare for the default language, `?lang=<code>` otherwise. A footer
 * wildcard shows as its prefix (`/casino/*` → `/casino`) and a dynamic page with its `:x` segments as `x`.
 */
export const previewUrl = (siteUrl: string, path: string, language: string, defaultLanguage: string): string => {
  const base = siteUrl.replace(/\/+$/, '');
  const shown = path.replace(/\/\*$/, '').replace(/\/:([^/]+)/g, '/$1') || '/';
  const query = language === defaultLanguage ? '' : `?lang=${encodeURIComponent(language)}`;
  return `${base}${shown}${query}`;
};
